/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import React from 'react';
import ReactDOM from 'react-dom';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import { Box, Divider, Link } from 'components/ui';
import ShipAddressForm from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/ShipAddressForm';
import orderUtils from 'utils/Order';
import store from 'store/Store';
import OrderActions from 'actions/OrderActions';
import Debounce from 'utils/Debounce';
import Actions from 'Actions';
import AddressActions from 'actions/AddressActions';
import ShipAddressActions from 'actions/ShipAddressActions';
import userUtils from 'utils/User';
import ErrorsUtils from 'utils/Errors';
import decorators from 'utils/decorators';
import { INTERSTICE_DELAY_MS } from 'constants/Checkout';
import checkoutBindings from 'analytics/bindings/pages/checkout/checkoutBindings';
import UI from 'utils/UI';
import updatePreferredZipCode from 'services/api/profile/updatePreferredZipCode';
import addressUtils from 'utils/Address';
import { VALIDATE_ADDRESS } from 'constants/actionTypes/order';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Storage from 'utils/localStorage/Storage';
import anaConsts from 'analytics/constants';
import selfReturnApi from 'services/api/selfReturn';
import { saveAndContinue as handleNewDefaultAddress } from 'services/Checkout';
import processEvent from 'analytics/processEvent';
import cookieUtils from 'utils/Cookies';
import TaxClaimUtils from 'utils/TaxClaim';
import FrictionlessUtils from 'utils/FrictionlessCheckout';
import FrictionlessCheckoutBindings from 'analytics/bindingMethods/pages/FrictionlessCheckout/FrictionlessCheckoutBindings';
import { SECTION_NAMES } from 'constants/frictionlessCheckout';
import { colors } from 'style/config';
import ShipAddressListItem from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/Section/ShipAddressListItem/ShipAddressListItem';
import ErrorConstants from 'utils/ErrorConstants';
import Empty from 'constants/empty';
import NewShipAddressModal from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/Section/NewShipAddressModal/NewShipAddressModal';
import AccessPointModal from 'components/FrictionlessCheckout/DeliverToReleaseThree/AccessPoint/AccessPointModal';
import NewDefaultAddress from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/Section/NewDefaultAddress/NewDefaultAddress';
import * as addressFingerprintUtils from 'utils/addressFingerprint';

const { setErrorsFromCheckoutAPI } = FrictionlessUtils;
const { isHalAddress } = orderUtils;

const { hasAVS, formatZipCode } = addressUtils;
const { ERROR_CODES } = ErrorConstants;

const CA_RESTRICTED_ITEM_CONTEXT = 'item.californiaRestricted';

let unsubscribe;

class ShipAddressSection extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            openAddressForm: this.props.openAddressForm || false,
            addressesToDisplay: this.calculateAddressToDisplay(),
            currentShipAddressId: this.props.shippingAddress && this.props.shippingAddress.addressId,
            shippingMethod: this.props.shippingMethod,
            showNewShipAddressModal: false,
            showAccessPointModal: false,
            orderedProfileAddresses: this.orderProfileAddresses(),
            highlightedFields: []
        };
        this.isAddingNewAddress = false;
        this.prevDefaultId = null;
        this.shallCheckAddressNeedsConfirmation = true;
        this.wasNewUserFlow = false;
    }

    calculateAddressToDisplay = () => {
        return isHalAddress(this.props.profileAddresses?.[0]) ? 4 : 3;
    };

    orderProfileAddresses = () => {
        const { profileAddresses } = this.props;
        const currentSelectedAddressId = this.props.shippingAddress && this.props.shippingAddress.addressId;
        let matchedAddress = null;

        if (profileAddresses.length && !isHalAddress(profileAddresses?.[0])) {
            // Always reorder to show the currently selected address first
            if (currentSelectedAddressId) {
                const orderedAddresses = [];
                profileAddresses.forEach(address => {
                    if (address.addressId === currentSelectedAddressId) {
                        matchedAddress = address;
                    } else {
                        orderedAddresses.push(address);
                    }
                });

                return matchedAddress ? [matchedAddress, ...orderedAddresses] : profileAddresses;
            }

            // If no address is selected, return backend order as-is
            return profileAddresses;
        }

        return profileAddresses;
    };

    verifyCaliforniaRestrictedItems = () => {
        const hasItemLevelMessages = this.props.orderItems.find(item => item.itemLevelMessages.length > 0);

        if (hasItemLevelMessages) {
            const isCARestictedItem = hasItemLevelMessages.itemLevelMessages.find(item => item.messageContext === CA_RESTRICTED_ITEM_CONTEXT);

            if (isCARestictedItem?.messages?.length) {
                // Check the actual saved shipping address from props (source of truth) instead of instance variable
                // which can be stale when new addresses are added
                if (this.props.shippingAddress && this.props.shippingAddress?.state !== 'CA') {
                    this.props.clearNamedSectionErrors([SECTION_NAMES.SDD, SECTION_NAMES.DELIVER_TO, SECTION_NAMES.GIFT_CARD_DELIVERY]);
                } else {
                    const errors = FrictionlessUtils.setDeliverToErrors(isCARestictedItem?.messages?.join(' '));
                    this.props.setCheckoutSectionErrors(errors);
                }
            }
        }
    };

    componentDidMount() {
        const { analyticsCallback, profileAddresses, isNewUserFlow } = this.props;
        const rendersAddressForm = isNewUserFlow || profileAddresses?.length === 0;

        if (isHalAddress(profileAddresses?.[0])) {
            this.setState({ currentShipAddressId: profileAddresses[0].addressId });
            this.setNewShippingAddress(profileAddresses[0]);
            this.shallCheckAddressNeedsConfirmation = false;
            this.props.setAddressNeedsConfirmation(false);
        }

        if (!rendersAddressForm) {
            //we only call this for L2 view.
            typeof analyticsCallback === 'function' && analyticsCallback();
        }

        unsubscribe = store.watchAction(VALIDATE_ADDRESS, action => {
            this.setState({ openAddressForm: false });
            this.validateAddress(action.addressId, action.uiAddress);
        });

        if (!profileAddresses?.length) {
            this.props.setIsAddingNewAddress?.(true);
        }

        this.verifyCaliforniaRestrictedItems();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isNCR) {
            this.setState({ currentShipAddressId: nextProps.profileAddresses[0].addressId });
            this.setNewShippingAddress(nextProps.profileAddresses[0]);
        }
    }

    handleShowMoreOnClick = () => {
        const newDisplayNum = this.props.orderedProfileAddresses?.length;

        const refKeys = Object.keys(this.refs);

        this.setState({ addressesToDisplay: newDisplayNum }, () => {
            const element = ReactDOM.findDOMNode(this.refs[refKeys[refKeys.length - 1]]);
            element.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });

            if (this.props.isNCR) {
                checkoutBindings.processAsyncPageLoad('show more addresses', anaConsts.PAGE_TYPES.REPLACEMENT_ORDER);
            }
        });
    };

    handleShowLessOnClick = () => {
        //after user clicks show less link,
        //return user to display of default 3 addresses
        this.setState({ addressesToDisplay: this.calculateAddressToDisplay() }, () => {
            const element = ReactDOM.findDOMNode(this.refs.shipAddress0);
            element.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
        });
    };

    setAnalyticsAndErrors = (sectionName, errors) => {
        if (Object.keys(errors)?.length > 0) {
            FrictionlessCheckoutBindings.setSectionLevelErrorAnalytics(sectionName, errors[sectionName]);
            this.props.setCheckoutSectionErrors(errors);
        }
    };

    showAddShipAddressForm = e => {
        const { maximumAddressesReached, ok, deleteSavedAddresses } = this.props;

        e.preventDefault();

        const maxShippingAddress = Number(Sephora.configurationSettings.maxShippingAddress);

        if (this.props.profileAddresses.length >= maxShippingAddress) {
            const title = maximumAddressesReached;
            const message = deleteSavedAddresses;
            const confirmButtonText = ok;

            store.dispatch(
                Actions.showInfoModal({
                    isOpen: true,
                    title: title,
                    message: message,
                    buttonText: confirmButtonText,
                    hasShadowBorderForSMUI: true
                })
            );
        } else {
            this.props.setIsAddingNewAddress?.(true);
            this.isAddingNewAddress = true;
            // GIM-5639: a fresh add form must never inherit a prior edit's highlighted fields.
            this.setState({ openAddressForm: true, editAddress: null, highlightedFields: [] });
        }
    };

    showEditShipAddressForm = (address, highlightedFields = []) => {
        this.setState({
            openAddressForm: true,
            editAddress: address,
            highlightedFields
        });
    };

    componentDidUpdate(prevProps) {
        const anAddressWasRemoved = prevProps.profileAddresses.length > this.props.profileAddresses.length;
        const anAddressWasAdded = prevProps.profileAddresses.length < this.props.profileAddresses.length;

        if ((anAddressWasRemoved || anAddressWasAdded) && this.props.profileAddresses.length > 0) {
            const defaultAddressId = this.props.profileAddresses.find(addr => addr.isDefault)?.addressId;
            const isDifferentDefaultAddress = this.prevDefaultId && this.prevDefaultId !== defaultAddressId;
            this.setState({ orderedProfileAddresses: this.orderProfileAddresses() });

            if (isDifferentDefaultAddress && prevProps.profileAddresses?.length) {
                this.setState({ showNewShipAddressModal: true, currentShipAddressId: defaultAddressId });

                // Early return: Don't run CA verification while modal is awaiting user confirmation
                // Verification will run after user confirms their selection and modal closes
                return;
            }
        }

        if (anAddressWasRemoved && this.props.profileAddresses.length === 0) {
            this.setState({
                editAddress: null,
                openAddressForm: false,
                orderedProfileAddresses: []
            });
        }

        this.checkForConfirmationFlag(prevProps);

        if (!prevProps.profileAddresses?.length && this.props.profileAddresses?.length) {
            this.props.setIsAddingNewAddress?.(false);
            this.setState({ orderedProfileAddresses: this.orderProfileAddresses() });
            this.wasNewUserFlow = true;
        }

        // Update ordered addresses when shipping address changes
        // Backend returns addresses in correct order, we just need to update state
        const shippingAddressIdChanged = prevProps.shippingAddress?.addressId !== this.props.shippingAddress?.addressId;

        if (shippingAddressIdChanged && this.props.profileAddresses.length > 0) {
            this.setState({ orderedProfileAddresses: this.orderProfileAddresses(), currentShipAddressId: this.props.shippingAddress?.addressId });

            if (!this.newShippingAddress && this.props.shippingAddress) {
                this.setNewShippingAddress(this.props.shippingAddress);
            }
        }

        // Only verify CA restricted items when relevant props actually change:
        // 1. shippingAddress changed (different address selected or address state changed)
        // 2. orderItems changed (items added/removed from basket)
        // 3. Modal is NOT showing (don't verify during transient state awaiting user input)
        // This prevents race conditions where verification runs with stale address data
        // or interferes with modal display
        const shippingAddressChanged = shippingAddressIdChanged || prevProps.shippingAddress?.state !== this.props.shippingAddress?.state;
        const orderItemsChanged = prevProps.orderItems !== this.props.orderItems;

        if (!this.state.showNewShipAddressModal && (shippingAddressChanged || orderItemsChanged)) {
            this.verifyCaliforniaRestrictedItems();
        }
    }

    checkForConfirmationFlag = prevProps => {
        // Reset addressNeedsToBeConfirmed flag for HAL addresses when shipping group becomes complete
        // or when shipping group is complete and user exists edit View
        const prevIsComplete = prevProps.shippingGroups?.shippingGroupsEntries?.[0]?.shippingGroup?.isComplete;
        const currentIsComplete = this.props.shippingGroups?.shippingGroupsEntries?.[0]?.shippingGroup?.isComplete;
        const shippingGroupBecameComplete = !prevIsComplete && currentIsComplete;
        const hasHalAddress = isHalAddress(this.props.shippingAddress);

        if (
            (shippingGroupBecameComplete && hasHalAddress && this.props.addressNeedsConfirmation) ||
            (prevProps.isEditView && !this.props.isEditView && currentIsComplete)
        ) {
            this.shallCheckAddressNeedsConfirmation = false;
            this.setConfirmationFlag(false);
            this.props.clearNamedSectionErrors([this.props.isGiftCardSection ? SECTION_NAMES.GIFT_CARD_DELIVERY : SECTION_NAMES.DELIVER_TO]);
        }
    };

    setConfirmationFlag = value => {
        const { isGiftCardSection, setGiftCardAddressNeedsConfirmation, setAddressNeedsConfirmation } = this.props;
        const method = isGiftCardSection ? setGiftCardAddressNeedsConfirmation : setAddressNeedsConfirmation;
        method(value);
    };

    showRemoveShipAddressModal = (addressId, isDefault, e) => {
        const { areYouSureMessage, removeAddress, cancelButton } = this.props;
        e.preventDefault();

        this.fireRemoveAddressModalAnalytics();

        //variable declaration here for clarity
        const title = removeAddress;
        const message = areYouSureMessage;
        const confirmButtonText = removeAddress;
        const cancelButtonText = cancelButton;

        const callback = () => {
            const orderId = orderUtils.getOrderId();
            ShipAddressActions.removeOrderShippingAddress(orderId, this.props.shippingGroupId, addressId)
                .then(() => {
                    this.fireRemoveAddressAnalytics();

                    //if current addressId user removes is the current orderShipAddressId
                    //we need to update the order details since now user has no order shipping address
                    if (this.props.shippingAddress && addressId === this.props.shippingAddress.addressId) {
                        ShipAddressActions.getOrderDetails(orderId).catch(this.handleResponseError);
                    }

                    if (isDefault) {
                        this.prevDefaultId = addressId;
                    }

                    ShipAddressActions.getAddressBook(this.props.isReshipOrder || false)
                        .then(addressData => {
                            const { addressList = [] } = addressData;
                            AddressActions.updateDefaultShippingAddressData(addressList);
                        })
                        .catch(this.handleResponseError);
                })
                .catch(this.handleResponseError);
        };

        store.dispatch(
            Actions.showInfoModal({
                isOpen: true,
                title: title,
                message: message,
                buttonText: confirmButtonText,
                callback: callback,
                cancelText: cancelButtonText,
                showCancelButtonLeft: true,
                hasShadowBorderForSMUI: true
            })
        );
    };

    fireRemoveAddressModalAnalytics = () => {
        const eventData = {
            data: {
                pageType: anaConsts.PAGE_TYPES.CHECKOUT,
                pageName: anaConsts.PAGE_NAMES.REMOVE_ADDRESS_MODAL_OPEN
            }
        };
        processEvent.process(anaConsts.ASYNC_PAGE_LOAD, eventData);
    };

    fireRemoveAddressAnalytics = () => {
        const eventData = {
            data: {
                actionInfo: anaConsts.ACTION_INFO.SHIPPING_ADDRESS_REMOVE,
                previousPage: digitalData.page.attributes.sephoraPageInfo.pageName,
                pageType: anaConsts.PAGE_TYPES.CHECKOUT,
                pageName: anaConsts.PAGE_NAMES.REMOVE_ADDRESS_MODAL_OPEN
            }
        };

        processEvent.process(anaConsts.LINK_TRACKING_EVENT, eventData);
    };

    showRemoveShipAddressModalDebounce = Debounce.preventDoubleClick(this.showRemoveShipAddressModal);

    closeAddressForm = () => {
        this.setState({
            openAddressForm: false,
            editAddress: null,
            highlightedFields: []
        });

        this.props.setIsAddingNewAddress?.(false);
        this.isAddingNewAddress = false;
    };

    handleCancelNewUserAddressForm = () => {
        this.closeAddressForm();

        if (typeof this.props.setAccessPoint === 'function') {
            this.props.setAccessPoint(false);
        }
    };

    updateNcrShippingAddress = addressData => {
        const { onAddressSelect } = this.props;

        if (typeof onAddressSelect === 'function') {
            onAddressSelect(addressData);
        }
    };

    setNewShippingAddress = (addressData = {}, triggerUpdateNcrShippingAddress = false) => {
        const { currentShipAddressId, showNewShipAddressModal } = this.state;
        const { shippingAddress } = this.props;
        const isNewAddressHal = isHalAddress(addressData);
        const isCurrentAddressHal = isHalAddress(shippingAddress);
        let userSelectedNewAddress;

        if (isNewAddressHal || isCurrentAddressHal) {
            userSelectedNewAddress = true;
        } else {
            userSelectedNewAddress = currentShipAddressId !== addressData.addressId;
        }

        if (!userSelectedNewAddress || currentShipAddressId === addressData.addressId) {
            return;
        }

        const newAddressData = Object.assign({}, addressData);
        const isPOBoxAddress = newAddressData.isPOBoxAddress;
        const addressType = newAddressData.addressType;

        /* need to remove address.isDefault, address.isAddressVerified, address.isPOBoxAddress, address.addressType
        from data we send to update order shipping address */
        delete newAddressData.isDefault;
        delete newAddressData.isAddressVerified;
        delete newAddressData.formattedPhone;
        delete newAddressData.isPOBoxAddress;
        delete newAddressData.addressType;

        this.newShippingAddress = {
            address: newAddressData,
            isPOBoxAddress,
            addressType,
            isDefaultAddress: showNewShipAddressModal ? true : addressData.isDefault,
            shippingGroupId: this.props.shippingGroupId,
            addressValidated: hasAVS(addressData.country) && addressData.isAddressVerified ? true : undefined
        };

        this.setState({ currentShipAddressId: newAddressData.addressId }, () => {
            if (triggerUpdateNcrShippingAddress) {
                this.updateNcrShippingAddress(this.newShippingAddress);
            }
        });

        // Reset confirmation flag for HAL addresses since they don't go through validateAddress
        if (isNewAddressHal) {
            this.shallCheckAddressNeedsConfirmation = false;
            this.props.setAddressNeedsConfirmation(false);
        }
    };

    moveToNextSection = address => {
        const { country, addressId } = address;

        if (hasAVS(country)) {
            this.validateAddress(addressId);
        } else {
            this.props.saveAddress(this);
        }
    };

    saveAndContinue = e => {
        e.preventDefault();
        FrictionlessCheckoutBindings.thisAddressButtonAnalytics(
            this.props.sectionName,
            !this.newShippingAddress ? this.props.shippingAddress?.isDefault : this.newShippingAddress?.isDefaultAddress
        );

        if (!this.newShippingAddress && !this.props.shippingAddress) {
            //if user hasn't selected a newShippingAddress or has removed the currentShippingAddress,
            //then there is no currentShippingAddress and user stays on section
        } else if (!this.newShippingAddress && this.props.shippingAddress) {
            //if user hasn't selected a newShippingAddress but
            //there is a currentShippingAddress, move on to next section without calling get order api
            //and if it has AVS validate it first
            this.moveToNextSection(this.props.shippingAddress);
        } else {
            //if user has selected a newShippingAddress make updateShippingAddress api call
            //and validate address
            const postalCode = formatZipCode(this.newShippingAddress.address.postalCode);

            updatePreferredZipCode({ postalCode })
                .then(zipCodeData => {
                    const zipData = {
                        preferredZipCode: zipCodeData.zipCode,
                        encryptedStoreIds: zipCodeData.encryptedStoreIds
                    };
                    Storage.session.setItem(LOCAL_STORAGE.PREFERRED_ZIP_CODE, zipData);

                    if (Sephora.configurationSettings.setZipStoreCookie) {
                        cookieUtils.write('sameDayZipcodeCookie', zipCodeData.zipCode, null, false, false);
                    }

                    ShipAddressActions.updateShippingAddress(this.newShippingAddress)
                        .then(data => {
                            if (data.scheduledAddrChangeMessage) {
                                store.dispatch(OrderActions.showScheduledDeliveryUnavailable(data.scheduledAddrChangeMessage[0].messages[0]));
                                const errors = setErrorsFromCheckoutAPI(data);
                                this.setAnalyticsAndErrors(SECTION_NAMES.SDD, errors);
                            }

                            this.validateAddress(this.newShippingAddress.address.addressId);
                        })
                        .catch(this.handleResponseError);
                })
                .catch(this.handleResponseError);
        }
    };

    saveAndContinueDebounce = Debounce.preventDoubleClick(this.saveAndContinue);

    /**
     * GIM-5455 (E2-6): skip-gate for the AVS call on a saved/selected address.
     *
     * V2 (avsLoqateV2): a verified saved address (addressValidated=true) skips the call;
     * otherwise the fingerprint-keyed session memory decides — soft/hard-blocked addresses re-prompt
     * on resubmit, an already-resolved (accepted/suggested/bypassed) fingerprint is not re-checked.
     * The fingerprint memory REPLACES the legacy validation-count throttle on the V2 path.
     *
     * Legacy (flag off): preserve the prior behaviour — skip when already verified or the session
     * validation count has been reached.
     */
    shouldRunAvs = addressData => {
        if (Sephora.configurationSettings?.avsLoqateV2) {
            return addressFingerprintUtils.shouldValidateAddress({
                address: addressData,
                addressValidated: addressData.isAddressVerified
            });
        }

        const maxAddressValidationCount = Storage.session.getItem(LOCAL_STORAGE.MAX_ADDRESS_VALIDATION_COUNT);
        const hasReachedMaxValidations = maxAddressValidationCount >= Sephora.configurationSettings.maxAddressValidationCount;

        return !addressData.isAddressVerified && !hasReachedMaxValidations;
    };

    validateAddress = (addressId, originalAddress) => {
        ErrorsUtils.clearErrors();
        this.props.clearNamedSectionErrors([SECTION_NAMES.SDD, SECTION_NAMES.DELIVER_TO, SECTION_NAMES.GIFT_CARD_DELIVERY]);
        this.shallCheckAddressNeedsConfirmation = false;
        /* Do not validate for the following scenarios:
            - AVS flag is off or it is International
        */
        const shipCountry = userUtils.getShippingCountry().countryCode;
        const { isNCR } = this.props;
        const orderId = orderUtils.getOrderId();

        if (!hasAVS(shipCountry) || (!addressId && !this.props.isGuestCheckout)) {
            this.sectionSaved();

            return;
        }

        let getAddressBook = ShipAddressActions.getAddressBook;

        // Guest checkout validation process
        // Since guest addresses don't have real ids - use what we have in address
        // or generate a UUID since it's required for the API call
        if (this.props.isGuestCheckout && originalAddress && originalAddress.address) {
            getAddressBook = () =>
                Promise.resolve({
                    addressList: [
                        {
                            ...originalAddress.address,
                            isAddressVerified: originalAddress.addressValidated,
                            initialAddressId: originalAddress.address.addressId || UI.uuid(),
                            addressId
                        }
                    ]
                });
        }

        const increaseSessionAddressValidationCount = () => {
            const addressValidationCount = Storage.session.getItem(LOCAL_STORAGE.MAX_ADDRESS_VALIDATION_COUNT) + 1;
            Storage.session.setItem(LOCAL_STORAGE.MAX_ADDRESS_VALIDATION_COUNT, addressValidationCount);
        };

        /* When sending addressValidated=false 6 times, BE will send isAddressVerified=true all the time
        But we don't know about this counter on FE, that's why we need to get the Address Book
        and use the value isAddressVerified from BE instead of the isAddressVerified from the form */
        getAddressBook(this.props.isReshipOrder || false)
            .then(addressBook => {
                const addressData = addressBook.addressList.find(address => address.addressId === addressId);
                const pageType = isNCR ? anaConsts.PAGE_TYPES.REPLACEMENT_ORDER : undefined;

                // Update cached Shipping Address
                AddressActions.updateDefaultShippingAddressData(addressBook.addressList);

                // Retrigger fetchSamples on Order Replacement flow when default address changes
                if (addressData && isNCR) {
                    this.props.fetchSamples().catch(() => {
                        Sephora.logger.error('Error fetching samples');
                    });
                }

                // GIM-5455 (E2-6): skip-gate — a verified saved address (or an already-resolved
                // fingerprint on the V2 path) proceeds without an AVS call. Flag-off keeps the legacy
                // verified-flag + validation-count throttle (byte-for-byte).
                if (!addressData || !this.shouldRunAvs(addressData)) {
                    this.sectionSaved();

                    return;
                }

                // Substitute an addressId with an "initial" one. For guests cases
                if (!addressId && addressData.initialAddressId) {
                    addressData.addressId = addressData.initialAddressId;
                }

                delete addressData.initialAddressId;

                // Set new Shipping Address so when the user ignores the modal it keeps the correct address selected
                this.setNewShippingAddress(addressData);

                // Clean the address details for API Calls
                const isDefaultAddress = addressData.isDefault;

                delete addressData.isAddressVerified;
                delete addressData.isDefault;
                delete addressData.formattedPhone;
                delete addressData.isPOBoxAddress;
                delete addressData.addressType;

                const updateAddressApi = isNCR
                    ? decorators.withInterstice(selfReturnApi.updateAddress, INTERSTICE_DELAY_MS)
                    : ShipAddressActions.updateShippingAddress;

                // API Call
                decorators.withInterstice(AddressActions.validateAddress, INTERSTICE_DELAY_MS)(
                    addressData,
                    {
                        // When user accepts the recommended address
                        RECOMMENDED: recommendedAddress => {
                            const recommendedIsPOBoxAddress = recommendedAddress.isPOBoxAddress;
                            const recommendedAddressType = recommendedAddress.addressType;

                            // Clean the recommendedAddress details for API Calls
                            delete recommendedAddress.isPOBoxAddress;
                            delete recommendedAddress.addressType;

                            const dataToSend = {
                                address: Object.assign({}, addressData, recommendedAddress),
                                isPOBoxAddress: recommendedIsPOBoxAddress,
                                addressType: recommendedAddressType,
                                isDefaultAddress,
                                addressValidated: true,
                                shippingGroupId: this.props.shippingGroupId,
                                ...(isNCR && {
                                    replacementOrderId: orderId
                                })
                            };
                            updateAddressApi(dataToSend)
                                .then(() => this.sectionSaved(true))
                                .catch(this.handleResponseError);
                        },
                        // When user clicks EDIT ADDRESS for unverified modal
                        UNVERIFIED: highlightedFields => {
                            addressData.isDefault = isDefaultAddress;
                            this.showEditShipAddressForm(addressData, highlightedFields);
                            increaseSessionAddressValidationCount();
                        }
                    },
                    // When user decides to use the unverified address or when closing the modal
                    () => {
                        increaseSessionAddressValidationCount();

                        const dataToSend = {
                            address: Object.assign({}, addressData),
                            isDefaultAddress,
                            addressValidated: false,
                            shippingGroupId: this.props.shippingGroupId,
                            ...(isNCR && {
                                replacementOrderId: orderId
                            })
                        };
                        updateAddressApi(dataToSend).then(this.sectionSaved).catch(this.handleResponseError);
                    },
                    pageType,
                    !this.props.isGuestCheckout && !this.wasNewUserFlow,
                    true
                );
            })
            .catch(this.handleResponseError);
    };

    sectionSaved = (shouldCallGetAddressAPI = false) => {
        const { isNCR } = this.props;

        if (this.isAddingNewAddress) {
            this.isAddingNewAddress = false;
            this.props.setIsAddingNewAddress?.(false);
        }

        if (!isNCR) {
            this.props.saveAddress(this, false);
        }

        if (shouldCallGetAddressAPI) {
            ShipAddressActions.getAddressBook(this.props.isReshipOrder || false);
        }

        // Notify parent that the address section was explicitly saved so it can clear
        // forced edit mode set for initially unverified addresses (otherwise isEditView stays
        // true, re-asserting addressNeedsToBeConfirmed and blocking Place Order).
        this.props.onAddressSaved?.();

        processEvent.process(anaConsts.ADD_SHIPPINGINFO_EVENT, {
            data: {}
        });
    };

    shouldRenderErrorAsAModal = errorData => {
        return Object.keys(errorData?.errors || Empty.Object).includes(ERROR_CODES.ADDRESS_IN_USE);
    };

    handleResponseError = errorData => {
        const isErrorModal = this.shouldRenderErrorAsAModal(errorData);

        if (this.props.isSdd && !isErrorModal) {
            errorData.sameDay = true;
            const errors = setErrorsFromCheckoutAPI(errorData);
            this.setAnalyticsAndErrors(SECTION_NAMES.SDD, errors);
        }

        //Allow the error to be rendered as a Modal.
        if (!isErrorModal) {
            const errors = FrictionlessUtils.setDeliverToErrors(errorData.errorMessages?.join(' '), this.props.isGiftCardSection);
            this.props.setCheckoutSectionErrors(errors);
        }

        ErrorsUtils.collectAndValidateBackEndErrors(errorData, this);
    };

    componentWillUnmount() {
        unsubscribe();
    }

    handleShowEditShipAddressForm = address => () => {
        if (!isHalAddress(address)) {
            this.showEditShipAddressForm(address);
        }
    };

    handleSetNewShippingAddress = address => () => {
        this.setNewShippingAddress(address, true);
    };

    renderLinks = hasHalAddress => {
        const { addShippingAddress, showMoreAddresses, showLessAddresses, children } = this.props;

        const { addressesToDisplay, orderedProfileAddresses } = this.state;
        const hasUptoThreeAddress = orderedProfileAddresses?.length <= 3;

        return (
            <>
                {!hasUptoThreeAddress ? (
                    <Box color={colors.gray}>
                        {!!children && !hasHalAddress && <Divider marginY={4} />}
                        <Link
                            color='blue'
                            paddingY={2}
                            paddingRight={1}
                            marginY={-2}
                            data-at={Sephora.debug.dataAt('addressShowMore')}
                            onClick={addressesToDisplay < orderedProfileAddresses.length ? this.handleShowMoreOnClick : this.handleShowLessOnClick}
                        >
                            {addressesToDisplay < orderedProfileAddresses.length ? showMoreAddresses : showLessAddresses}
                        </Link>{' '}
                        |{' '}
                        <Link
                            color='blue'
                            paddingY={2}
                            paddingLeft={1}
                            marginY={-2}
                            data-at={Sephora.debug.dataAt('addAddress')}
                            onClick={this.showAddShipAddressForm}
                        >
                            {addShippingAddress}
                        </Link>
                    </Box>
                ) : (
                    <>
                        {!!children && !hasHalAddress && <Divider marginY={4} />}
                        <Link
                            color='blue'
                            paddingY={2}
                            paddingLeft={1}
                            marginY={-2}
                            data-at={Sephora.debug.dataAt('addAddress')}
                            onClick={this.showAddShipAddressForm}
                        >
                            {addShippingAddress}
                        </Link>
                    </>
                )}
            </>
        );
    };

    renderItemList = (hasHalAddress = false) => {
        const {
            isNCR,
            taxExemptAddressLabel,
            removeAddressLabel,
            remove,
            editAddressLabel,
            edit,
            useThisAddress,
            pickupLabel,
            addressNeedsConfirmation,
            giftAddressNeedsConfirmation,
            shippingGroups,
            isEditView,
            isGiftCardSection
        } = this.props;

        const isShippingGroupComplete = shippingGroups?.shippingGroupsEntries?.[0]?.shippingGroup?.isComplete;
        const shouldSetConfirmationFlag = !isShippingGroupComplete && this.shallCheckAddressNeedsConfirmation;

        const hasConfirmationFlagSet = isGiftCardSection ? giftAddressNeedsConfirmation : addressNeedsConfirmation;

        if (!hasConfirmationFlagSet && (shouldSetConfirmationFlag || isEditView)) {
            this.setConfirmationFlag(true);
        }

        const { addressesToDisplay, currentShipAddressId, orderedProfileAddresses } = this.state;

        const displayedShipAddresses = orderedProfileAddresses && orderedProfileAddresses.slice(0, addressesToDisplay);
        const showTaxExemptAddress = this.props.showTaxExemptAddress && TaxClaimUtils.isTaxExemptionEnabled();

        return (
            <>
                {displayedShipAddresses.map((address, index) => {
                    const halAddress = isHalAddress(address);

                    return (
                        <div
                            data-at={Sephora.debug.dataAt('shippingAddress')}
                            ref={`shipAddress${index}`}
                            key={address.addressId}
                        >
                            <ShipAddressListItem
                                address={address}
                                isNCR={isNCR}
                                currentShipAddressId={currentShipAddressId}
                                showTaxExemptAddress={showTaxExemptAddress}
                                taxExemptAddressLabel={taxExemptAddressLabel}
                                removeAddressLabel={removeAddressLabel}
                                removeLabel={remove}
                                editAddressLabel={editAddressLabel}
                                editLabel={edit}
                                onSelect={this.handleSetNewShippingAddress(address)}
                                onRemove={e => this.showRemoveShipAddressModalDebounce(address.addressId, address.isDefault, e)}
                                onEdit={halAddress ? this.toggleAccessPointModal : this.handleShowEditShipAddressForm(address)}
                                saveAndContinueDebounce={this.saveAndContinueDebounce}
                                buttonText={useThisAddress}
                                hal={halAddress}
                                isRadio
                                fedexPickupLabel={pickupLabel}
                                labelName={'ShipAddressOption'}
                            />
                            {!isNCR && !hasHalAddress && <Divider marginY={4} />}
                            {hasHalAddress && index < displayedShipAddresses.length && <Divider marginY={4} />}
                        </div>
                    );
                })}
            </>
        );
    };

    closeNewShippingAddressModal = () => {
        this.setState({ showNewShipAddressModal: false });
    };

    toggleAccessPointModal = () => {
        this.setState(prevState => ({ showAccessPointModal: !prevState.showAccessPointModal }));
    };

    handleNewDefaultAddressConfirmation = ({ newDefaultAddress }) => {
        handleNewDefaultAddress(newDefaultAddress, this.validateAddress, this.setAnalyticsAndErrors, this.handleResponseError)();
    };

    renderViewExistingUser = () => {
        const {
            shippingGroupId,
            profileAddresses,
            isHalAvailable,
            isNCR,
            children,
            isSdd,
            isGiftCardSection,
            isCollapsed,
            taxExemptAddressLabel,
            removeAddressLabel,
            remove,
            editAddressLabel,
            edit,
            orderHasPhysicalGiftCard,
            addressByPreferredZipCode
        } = this.props;

        const { openAddressForm, editAddress, highlightedFields } = this.state;
        const hasHalAddress = isHalAddress(profileAddresses[0]);
        const addressAsDefault = profileAddresses.length === 1 && hasHalAddress;
        const showTaxExemptAddress = this.props.showTaxExemptAddress && TaxClaimUtils.isTaxExemptionEnabled();
        const isFirstAddress = profileAddresses.length === 0;

        return (
            <div>
                {this.state.showNewShipAddressModal && (
                    <NewShipAddressModal
                        isOpen={true}
                        saveAndContinueDebounce={this.saveAndContinueDebounce}
                        onDismiss={this.closeNewShippingAddressModal}
                        isSingleAddress={profileAddresses.length === 1}
                    >
                        <NewDefaultAddress
                            addresses={profileAddresses}
                            initialSelectedId={this.state.currentShipAddressId}
                            isNCR={isNCR}
                            showTaxExemptAddress={showTaxExemptAddress}
                            taxExemptAddressLabel={taxExemptAddressLabel}
                            removeAddressLabel={removeAddressLabel}
                            removeLabel={remove}
                            editAddressLabel={editAddressLabel}
                            editLabel={edit}
                            onAddressSelect={this.handleSetNewShippingAddress}
                            isSingleAddress={profileAddresses.length === 1}
                            updateNcrShippingAddress={this.updateNcrShippingAddress}
                            shippingGroupId={this.props.shippingGroupId}
                            onConfirm={this.handleNewDefaultAddressConfirmation}
                        />
                    </NewShipAddressModal>
                )}
                {openAddressForm ? (
                    <ShipAddressForm
                        key={editAddress?.addressId || 'new-address'}
                        address={editAddress}
                        highlightedFields={highlightedFields}
                        shippingGroupId={shippingGroupId}
                        cancelCallback={this.closeAddressForm}
                        isDefaultChecked={(editAddress && editAddress.isDefault) || addressAsDefault}
                        isHalAvailable={isHalAvailable}
                        isNCR={isNCR}
                        isSdd={isSdd}
                        addressByPreferredZipCode={addressByPreferredZipCode}
                        hasUserOpenedAddressForm={true}
                        isGiftCardSection={isGiftCardSection}
                        isCollapsed={isCollapsed}
                        isFirstAddress={isFirstAddress}
                        orderHasPhysicalGiftCard={orderHasPhysicalGiftCard}
                        sectionName={this.props.sectionName}
                        showCancelButtonInChild={this.props.showCancelButtonInChild}
                    >
                        {(profileAddresses.length === 0 || addressAsDefault) && children}
                    </ShipAddressForm>
                ) : (
                    <React.Fragment>
                        {this.renderItemList(hasHalAddress)}
                        {!hasHalAddress && <>{children}</>}
                        {this.renderLinks(hasHalAddress)}
                    </React.Fragment>
                )}
            </div>
        );
    };

    setAccessPointFromModal = accessPoint => {
        this.props.setAccessPointFromModal(accessPoint, this.props.shippingGroupId, this.props.accessPointCallback, true);
    };

    render() {
        const {
            shippingAddress,
            shippingGroupId,
            profileAddresses,
            isNewUserFlow,
            orderHasPhysicalGiftCard,
            isGuestCheckout,
            isHalAvailable,
            children,
            isSdd,
            isGiftCardSection,
            isCollapsed,
            showAddressFormForHalGuestCheckout,
            currentAddressListLength,
            addressByPreferredZipCode
        } = this.props;

        const address = shippingAddress && !isHalAddress(shippingAddress) ? shippingAddress : null;

        const hasZeroAddress = currentAddressListLength === 0 || showAddressFormForHalGuestCheckout;

        return (
            <div>
                {isNewUserFlow || profileAddresses.length === 0 || showAddressFormForHalGuestCheckout ? (
                    <ShipAddressForm
                        key={address?.addressId || 'new-user-address'}
                        address={address}
                        shippingGroupId={shippingGroupId}
                        cancelCallback={this.handleCancelNewUserAddressForm}
                        isNewUser={isNewUserFlow}
                        isFirstAddress={hasZeroAddress}
                        isDefaultChecked={hasZeroAddress}
                        orderHasPhysicalGiftCard={orderHasPhysicalGiftCard}
                        isGuestCheckout={isGuestCheckout}
                        isHalAvailable={isHalAvailable}
                        isSdd={isSdd}
                        addressByPreferredZipCode={addressByPreferredZipCode}
                        hasUserOpenedAddressForm={false}
                        isGiftCardSection={isGiftCardSection}
                        isCollapsed={isCollapsed}
                        sectionName={this.props.sectionName}
                        showCancelButtonInChild={this.props.showCancelButtonInChild}
                    >
                        {children}
                    </ShipAddressForm>
                ) : (
                    this.renderViewExistingUser()
                )}
                {this.state.showAccessPointModal && (
                    <AccessPointModal
                        isOpen={this.state.showAccessPointModal}
                        onDismiss={this.toggleAccessPointModal}
                        callback={this.setAccessPointFromModal}
                    />
                )}
            </div>
        );
    }
}

export default wrapComponent(ShipAddressSection, 'ShipAddressSection');
